import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaButton {
  constructor() {
    this.variant = 'primary';
    this.arialabel = undefined;
    this.dataproduct = undefined;
    this.dataRotation = undefined;
    this.varientId = undefined;
    this.innerTabIndex = undefined;
    this.disabled = false;
    this.type = undefined;
    this.name = 'button';
    this.value = undefined;
    this.iconOnly = false;
    this.iconAlt = undefined;
    this.textOnly = true;
    this.iconWithText = false;
    this.path = undefined;
    this.pathWithHover = undefined;
    this.iconPosition = 'left';
    this.styles = undefined;
    this.upperCase = undefined;
    this.handleClick = undefined;
    this.onMouseDown = undefined;
    this.enableOnClick = true;
    this.onTouchStart = undefined;
    this.classes = undefined;
    this._id = undefined;
    this.imgAttribute = undefined;
    this.hover = false;
  }
  getButtonProps() {
    const props = {
      'ariaLabel': this.arialabel || null,
      'innerTabIndex': this.innerTabIndex || null,
      'disabled': this.disabled || false,
      'type': this.type || 'button',
      'name': this.name || 'button',
      'data-product': this.dataproduct || null,
      'data-varientId': this.varientId || null,
      'data-rotation': this.dataRotation || null,
    };
    return Object.assign({}, props);
  }
  handleMouseOver() {
    if (!this.disabled)
      this.hover = true;
  }
  handleMouseOut() {
    if (!this.disabled)
      this.hover = false;
  }
  render() {
    if (this.iconOnly)
      return (h(Host, { id: this._id ? this._id : '' }, this.styles && h("style", null, this.styles), h("button", Object.assign({ class: `btn ${this.getCssClassMap()}` }, this.getButtonProps(), { onClick: this.enableOnClick ? event => this.handleClick && this.handleClick(event) : null, disabled: this.disabled, onMouseDown: this.onMouseDown ? event => this.handleClick && this.handleClick(event) : null, onTouchStart: this.onTouchStart ? event => this.handleClick && this.handleClick(event) : null }), this.variant === 'primary' ? (this.variant === 'primary' && this.hover ? (h("img", Object.assign({}, this.imgAttribute, { src: this.path, alt: this.iconAlt ? this.iconAlt : this.value }))) : (h("img", Object.assign({}, this.imgAttribute, { src: this.pathWithHover, alt: this.iconAlt ? this.iconAlt : this.value })))) : null, this.variant === 'secondary' ? (this.variant === 'secondary' && this.hover ? (h("img", Object.assign({}, this.imgAttribute, { src: this.pathWithHover, alt: this.iconAlt ? this.iconAlt : this.value }))) : (h("img", Object.assign({}, this.imgAttribute, { src: this.path, alt: this.iconAlt ? this.iconAlt : this.value })))) : null)));
    if (this.textOnly)
      return (h(Host, { id: this._id ? this._id : '' }, this.styles && h("style", null, this.styles), h("button", Object.assign({ class: `btn ${this.getCssClassMap()}` }, this.getButtonProps(), { onClick: this.enableOnClick ? event => this.handleClick && this.handleClick(event) : null, onMouseDown: this.onMouseDown ? event => this.handleClick && this.handleClick(event) : null, onTouchStart: this.onTouchStart ? event => this.handleClick && this.handleClick(event) : null, disabled: this.disabled }), this.value)));
    if (this.iconWithText)
      return (h(Host, { id: this._id ? this._id : '' }, this.styles && h("style", null, this.styles), h("button", Object.assign({ class: `btn ${this.getCssClassMap()}` }, this.getButtonProps(), { onClick: this.enableOnClick ? event => this.handleClick(event) : null, onMouseDown: this.onMouseDown ? event => this.handleClick && this.handleClick(event) : null, onTouchStart: this.onTouchStart ? event => this.handleClick && this.handleClick(event) : null, disabled: this.disabled }), this.hover ? (h("img", Object.assign({}, this.imgAttribute, { src: this.pathWithHover, alt: this.iconAlt ? this.iconAlt : this.value }))) : (h("img", Object.assign({}, this.imgAttribute, { src: this.path, alt: this.iconAlt ? this.iconAlt : this.value }))), h("aiba-label", { tag: "span", text: this.value }))));
  }
  getCssClassMap() {
    return classNames('btn', `variant-${this.variant}`, this.iconOnly ? 'icon-only' : '', !this.iconOnly ? this.iconPosition : '', this.disabled ? 'disabled' : '', this.upperCase ? 'upper-case' : ' ', this.classes ? `${this.classes}` : '');
  }
  static get is() { return "aiba-button"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-button.css"]
    };
  }
  static get properties() {
    return {
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'primary'"
      },
      "arialabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "arialabel",
        "reflect": false
      },
      "dataproduct": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "dataproduct",
        "reflect": false
      },
      "dataRotation": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data-rotation",
        "reflect": false
      },
      "varientId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "varient-id",
        "reflect": false
      },
      "innerTabIndex": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "inner-tab-index",
        "reflect": false
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'reset' | 'submit' | 'button'",
          "resolved": "\"button\" | \"reset\" | \"submit\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "type",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false,
        "defaultValue": "'button'"
      },
      "value": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "value",
        "reflect": false
      },
      "iconOnly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-only",
        "reflect": false,
        "defaultValue": "false"
      },
      "iconAlt": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-alt",
        "reflect": false
      },
      "textOnly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text-only",
        "reflect": false,
        "defaultValue": "true"
      },
      "iconWithText": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-with-text",
        "reflect": false,
        "defaultValue": "false"
      },
      "path": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "path",
        "reflect": false
      },
      "pathWithHover": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "path-with-hover",
        "reflect": false
      },
      "iconPosition": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'left' | 'right'",
          "resolved": "\"left\" | \"right\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-position",
        "reflect": false,
        "defaultValue": "'left'"
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "upperCase": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "upper-case",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "onMouseDown": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-mouse-down",
        "reflect": false
      },
      "enableOnClick": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-on-click",
        "reflect": false,
        "defaultValue": "true"
      },
      "onTouchStart": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "on-touch-start",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "imgAttribute": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "img-attribute",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "hover": {}
    };
  }
  static get listeners() {
    return [{
        "name": "mouseover",
        "method": "handleMouseOver",
        "target": undefined,
        "capture": false,
        "passive": true
      }, {
        "name": "mouseout",
        "method": "handleMouseOut",
        "target": undefined,
        "capture": false,
        "passive": true
      }];
  }
}
//# sourceMappingURL=aiba-button.js.map
